import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const Dashboard = () => import('@/views/Dashboard')
const Error = () => import('@/views/Error')

//Views Base de Datos
const baseasegurado = () => import('@/views/basedatos/baseasegurado')
const basecorredores = () => import('@/views/basedatos/basecorredores')
const basemantcorredores = () => import('@/views/basedatos/basemantcorredores')

//Views Base de Datos resoluciones
const contactospoliza = () => import('@/views/basedatos-resoluciones/contactos-poliza')
const concorr = () => import('@/views/basedatos-resoluciones/corredores-contactos')
const corrasigcon = () => import('@/views/basedatos-resoluciones/corr-asignar-contacto')

//Views Renovaciones
const estadorenovaciones = () => import('@/views/renovaciones/estado-renovaciones')
const condicionesrenovacion = () => import('@/views/renovaciones/condiciones-renovacion')
const planillarenovaciones = () => import('@/views/renovaciones/planilla-renovaciones')

//Información Corredor
const baseinfcorredores = () => import('@/views/basedatos/baseinfcorredores')

//Informes Atradius
const mantenedorpolizas = () => import('@/views/informes-atradius/mantenedor-polizas')
const generarinformes = () => import('@/views/informes-atradius/generar-informes')

//cartas
const cambioecceac = () => import('@/views/cartas/cambio-ecc-eac')

//informes
const costovariableminimo = () => import('@/views/informes/costo-variable-minimo')
const porcaprlinpol =() => import('@/views/informes/porc-aprobacion-lineas-poliza')
const porcaproblingen = () => import('@/views/informes/porc-aprobacion-lineas-general') 
const mtoasegprima = () => import('@/views/informes/mto-aseg-vs-prima') 

//rubros
const listadorubros = () => import('@/views/rubros/listado-rubros')
const rubrospoliza = () => import('@/views/rubros/rubros-poliza')

//gestion ventas
const polizasnuevas = () => import('@/views/gestion-ventas/polizas-nuevas')
const inclusionrazonsocial = () => import('@/views/gestion-ventas/inclusion-razon-social')

// Views Consulta Clientes
const busquedapersonas = () => import('@/views/consultaClientes/busqueda-personas')


Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/inicio',
      name: 'Inicio',
      component: DefaultContainer,
      children: [
        {
          path: '403',
          name: 'Error',
          component: Error,
        },
        {
          path: 'inicio',
          name: 'Inicio',
          component: Dashboard
        },
        {
          path: '/basedatos',
          redirect: '/basedatos/baseasegurado',
          name: 'Base de Datos',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'baseasegurado',
            name: 'Asegurados',
            component: baseasegurado,

          }
          ]
        },
        {
          path: '/basedatos',
          redirect: '/basedatos/basecorredores',
          name: 'Base de Datos',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'basecorredores',
            name: 'Corredores',
            component: basecorredores,

          }
          ]
        },
        {
          path: '/basedatos',
          redirect: '/basedatos/basemantcorredores',
          name: 'Base de Datos',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'basemantcorredores',
            name: 'Mantenedor Corredores',
            component: basemantcorredores,
          }
          ]
        },
        {
          path: '/basedatos',
          redirect: '/basedatos/baseinfcorredores',
          name: 'Información Corredor',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'baseinfcorredores',
            name: 'Información Corredor',
            component: baseinfcorredores,
          }
          ]
        },
        {
          path: '/basedatos-resoluciones',
          redirect: '/basedatos-resoluciones/contactos-poliza',
          name: 'Contactos Póliza',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'contactos-poliza',
            name: 'Contactos Póliza',
            component: contactospoliza,

          }
          ]
        },

        {
          path: '/basedatos-resoluciones',
          redirect: '/basedatos-resoluciones/corredores-contactos',
          name: 'Base de Datos Resoluciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'corredores-contactos',
            name: 'Corredores Contactos',
            component: concorr,

          }
          ]
        },
        {
          path: '/basedatos-resoluciones',
          redirect: '/basedatos-resoluciones/corr-asignar-contacto',
          name: 'Base de Datos Resoluciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'corr-asignar-contacto',
            name: 'Asignar Contacto Corredor',
            component: corrasigcon,

          }
          ]
        },

        {
          path: '/renovaciones',
          redirect: '/renovaciones/estado-renovaciones',
          name: 'Estado de Renovaciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'estado-renovaciones',
            name: 'Estado de Renovaciones',
            component: estadorenovaciones,

          }
          ]
        },

        {
          path: '/renovaciones',
          redirect: '/renovaciones/condiciones-renovacion',
          name: 'Condiciones de Renovación',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'condiciones-renovacion',
            name: 'Condiciones de Renovación',
            component: condicionesrenovacion,

          }
          ]
        },

         {
          path: '/renovaciones',
          redirect: '/renovaciones/planilla-renovaciones',
          name: 'Planilla Renovaciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'planilla-renovaciones',
            name: 'Planilla Renovaciones',
            component: planillarenovaciones,

          }
          ]
        },
        
        {
          path: '/informes-atradius',
          redirect: '/informes-atradius/mantenedor-polizas',
          name: 'Informes Atradius',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'mantenedor-polizas',
            name: 'Mantenedor Pólizas',
            component: mantenedorpolizas,

          }
          ]
        },
        {
          path: '/informes-atradius',
          redirect: '/informes-atradius/generar-informes',
          name: 'Informes Atradius',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'generar-informes',
            name: 'Generar Informes',
            component: generarinformes,

          }
          ]
        },
        {
          path: '/cartas',
          redirect: '/cartas/cambio-ecc-eac',
          name: 'Cartas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'cambio-ecc-eac',
            name: 'Cambio ECC EAC',
            component: cambioecceac,

          }
          ]
        },
        {
          path: '/informes',
          redirect: '/informes/costo-variable-minimo',
          name: 'Informes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'costo-variable-minimo',
            name: 'Costo Variable Mínimo',
            component: costovariableminimo,

          }
          ]
        },
        {
          path: '/informes',
          redirect: '/informes/porc-aprobacion-lineas-poliza',
          name: 'Informes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'porc-aprobacion-lineas-poliza',
            name: 'Porc. Aprob. Líneas Póliza',
            component: porcaprlinpol,
          }
          ]
        },
        {
          path: '/informes',
          redirect: '/informes/porc-aprobacion-lineas-general',
          name: 'Informes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'porc-aprobacion-lineas-general',
            name: 'Porc. Aprob. Líneas General',
            component: porcaproblingen,

          }
          ]
        },
        {
          path: '/informes',
          redirect: '/informes/mto-aseg-vs-prima',
          name: 'Informes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'mto-aseg-vs-prima',
            name: 'Monto Asegurado v/s Prima',
            component: mtoasegprima,

          }
          ]
        },
        {
          path: '/rubros',
          redirect: '/rubros/listado-rubros',
          name: 'Listado Rubros',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'listado-rubros',
            name: 'Listado Rubros',
            component: listadorubros,

          }
          ]
        },
        {
          path: '/rubros',
          redirect: '/rubros/rubros-poliza',
          name: 'Rubros por Póliza',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'rubros-poliza',
            name: 'Rubros por Póliza',
            component: rubrospoliza,

          }
          ]
        },
        {
          path: '/gestion-ventas',
          redirect: '/gestion-ventas/polizas-nuevas',
          name: 'Gestión Ventas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'polizas-nuevas',
            name: 'Pólizas Nuevas',
            component: polizasnuevas,
          }
          ]
        },
        {
          path: '/gestion-ventas',
          redirect: '/gestion-ventas/inclusion-razon-social',
          name: 'Gestión Ventas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'inclusion-razon-social',
            name: 'Inclusión Razón Social',
            component: inclusionrazonsocial,
          }
          ]
        },
        {
          path: '/consultaClientes',
          redirect: '/consultaClientes/busquedaPersonas',
          name: 'Consulta Clientes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'busquedaPersonas',
            name: 'Busqueda de Personas',
            component: busquedapersonas,

          }
          ]
        },



      ]
    }
  ]
})
